import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Set BASE_URL via environment variable
export var BASE_URL = process.env.REACT_APP_RM_ENV && process.env.REACT_APP_RM_ENV === 'prod' ? 'https://livecms.roymorgan.com' : process.env.REACT_APP_RM_ENV && process.env.REACT_APP_RM_ENV === 'uat' ? 'https://livecms.roymorganuat.com' : 'https://livecms.roymorgandev.com';

/*
 * DO NOT MODIFY THIS METHOD
 *
 * API logic should not live inside this method
 * unless it's going to be used across multiple API calls.
 *
 * Please speak to Sean Gilmore if you have issues with this.
 */
export var callAPI = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var method = _ref2.method,
        targetUrl = _ref2.targetUrl,
        token = _ref2.token,
        headers = _ref2.headers,
        body = _ref2.body;
    var response, errorResponse, error, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(targetUrl, {
              method: method,
              headers: headers,
              body: JSON.stringify(body)
            });

          case 3:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            errorResponse = _context.sent;
            error = Error('Invalid API Response');

            error.msg = errorResponse.errors ? errorResponse.errors[0].message : errorResponse.statusMessage ? errorResponse.statusMessage : 'API Error';
            throw error;

          case 11:
            _context.next = 13;
            return response.json();

          case 13:
            json = _context.sent;
            return _context.abrupt('return', json);

          case 17:
            _context.prev = 17;
            _context.t0 = _context['catch'](0);
            throw _context.t0;

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 17]]);
  }));

  return function callAPI(_x) {
    return _ref.apply(this, arguments);
  };
}();